import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Address from "./Address";
import { getDate } from "../common/DisplayDate";

class BusinessBccNimbusItemRecordDetail extends Component {
  componentDidMount() { }

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const addresses = [];
      const debtorAddressNodes = _.get(node, "debtors[0].debtor[0].address");
      if (debtorAddressNodes !== undefined) {
        _.forEach(debtorAddressNodes, (debtorAddressNode, deptAddIndex) => {
          addresses.push(
            <span key={`Item_Debt_Address_${this.props.index}_${deptAddIndex}`}>
              <Address addressNode={debtorAddressNode} {...this.props} />
              <br />
            </span>
          );
        });
      }
      results.push(
        <Table.Row key={`Item_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell colSpan={5}>{addresses}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Item_Record_Filing_Row_${this.props.index}`}>
          <Table.Cell>Filing Type:</Table.Cell>
          <Table.Cell colSpan={2}>
            {_.get(node, "filingType[0]._", "")}
          </Table.Cell>
          <Table.Cell>Filing Number:</Table.Cell>
          <Table.Cell colSpan={2}>
            {_.get(node, "filingNumber[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Item_Record_Filing_Office_Row_${this.props.index}`}>
          <Table.Cell>Filing Office Name:</Table.Cell>
          <Table.Cell colSpan={2}>
            {_.get(node, "filingOfficeName[0]._", "")}
          </Table.Cell>
          <Table.Cell>Filing Date:</Table.Cell>
          <Table.Cell colSpan={2}>
            {getDate(_.get(node, "filingDate[0]"))}
          </Table.Cell>
        </Table.Row>
      );
      const expirationDateNodes = _.get(node, "expirationDate");
      if (expirationDateNodes !== undefined) {
        _.forEach(expirationDateNodes, (expirationDateNode, expIndex) => {
          results.push(
            <Table.Row key={`Exp_Date_Row_${this.props.index}_${expIndex}`}>
              <Table.Cell colSpan={3} />
              <Table.Cell>Expiration Date:</Table.Cell>
              <Table.Cell>{getDate(expirationDateNode)}</Table.Cell>
            </Table.Row>
          );
        });
      }
      const filingAddresses = [];
      const filingAddressNodes = _.get(node, "filingOfficeAddress");
      if (filingAddressNodes !== undefined) {
        _.forEach(filingAddressNodes, (filingAddressNode, deptAddIndex) => {
          filingAddresses.push(
            <span
              key={`Item_Filing_Address_${this.props.index}_${deptAddIndex}`}
            >
              <Address addressNode={filingAddressNode} {...this.props} />
              <br />
            </span>
          );
        });
      }
      results.push(
        <Table.Row key={`Item_Record_File_Off_Address_Row_${this.props.index}`}>
          <Table.Cell>Filing Address:</Table.Cell>
          <Table.Cell colSpan={5}>{filingAddresses}</Table.Cell>
        </Table.Row>
      );
      let securedPartyNodes = _.get(
        node,
        "securedParties[0].UCCSecuredParty[0].item"
      );
      if (securedPartyNodes === undefined) {
        securedPartyNodes = _.get(node, "securedParties[0].UCCSecuredParty");
      }
      if (securedPartyNodes !== undefined) {
        _.forEach(securedPartyNodes, (securedPartyNode, secIndex) => {
          results.push(
            <Table.Row key={`Sec_Party_Row_${this.props.index}_${secIndex}`}>
              <Table.Cell>Secured Party:</Table.Cell>
              <Table.Cell colSpan={5}>
                {_.get(securedPartyNode, "businessName[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );
          results.push(
            <Table.Row
              key={`Sec_Party_Address_Row_${this.props.index}_${secIndex}`}
            >
              <Table.Cell>Address:</Table.Cell>
              <Table.Cell colSpan={2}>
                <Address
                  key={`Item_Sec_Party_Address_${this.props.index}_${secIndex}`}
                  addressNode={_.get(securedPartyNode, "address[0]")}
                  {...this.props}
                />
                <br />
              </Table.Cell>
            </Table.Row>
          );
        });
      }
      const collateralNodes = _.get(
        node,
        "collateralItems[0].UCCCollateralItem[0].item"
      );
      if (collateralNodes !== undefined) {
        let prevCollatralContent = "";
        const contents = [];
        _.forEach(collateralNodes, collateralNode => {
          let content = "";
          _.forEach(Object.keys(collateralNode), key => {
            content = `${content} ${_.get(collateralNode, `${key}[0]._`, "")}`;
          });
          if (prevCollatralContent !== content) {
            contents.push(`[${content}]`);
            prevCollatralContent = content;
          }
        });
        results.push(
          <Table.Row key={`Coll_Row_${this.props.index}`}>
            <Table.Cell>UCC Collaterals</Table.Cell>
            <Table.Cell colSpan={5}>{`${contents}`}</Table.Cell>
          </Table.Row>
        );
      }
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default BusinessBccNimbusItemRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessBccNimbusItemRecordDetail.js